#overlay-content {
  min-height: 300px;
  max-height: 570px;
  width: 272px;
}

#in-product-trials-overlay-window-image {
  width: 100%;
  height: 109px;
  object-fit: cover;
}

#in-product-trials-overlay-window-title {
  color: var(--white-layout-300-primary);
  padding: 20px 0 14px 0;
}

#in-product-trials-overlay-window-text {
  color: var(--white-layout-300-primary);
  padding-bottom: 22px;
}

gz-button {
  padding-bottom: 5px;
}
